<template>
  <div v-if="registro">
    <Notificacao
      v-if="registro.obs_aplic && !removeAplicabilidade"
      :tipo="'aplicabilidade'"
      :texto="registro.obs_aplic"
      :cnae="cnae ? cnae : null"
      :municipios="municipios"
    />
    <Notificacao
      v-if="registro.obs_inaplic && !removeInaplicabilidade"
      :tipo="'inaplicabilidade'"
      :texto="registro.obs_inaplic"
    />
    <Notificacao
      v-if="registro.obs && !removeObservacao"
      :tipo="'observação'"
      :texto="registro.obs"
    />
    <Notificacao
      v-if="registro.nota && !removeNota"
      :tipo="'nota'"
      :texto="registro.nota"
      :baseLegal="baseLegalNota ? baseLegalNota : null"
    />
  </div>
</template>

<script>
import Notificacao from "@/components/Notificacao/Notificacao.vue";

export default {
  name: "GrupoNotificacao",
  props: {
    removeAplicabilidade: Boolean,
    removeInaplicabilidade: Boolean,
    removeObservacao: Boolean,
    removeNota: Boolean,
    registro: Object,
    cnae: String,
    municipios: String,
    baseLegalNota: String,
  },
  components: {
    Notificacao
  }
};
</script>

<style lang="scss" scoped></style>
